import moment from "moment";
import { useGetWalletTransactionsQuery } from "../../store/api/walletApi";
import { useEffect, useState } from "react";
import { Info } from "../../icons";
import RewardsCriteria from "./rewards-popup";

interface WalletLedgers {
  _id: string;
  entity?: string;
  action: string;
  amount: number;
  transaction_type: string;
  created_at: Date | string;
  updated_at: Date | string;
  updated_to: number;
  updated_from: number;
}

const formatMonthYear = (monthYear: string) => {
  const month = monthYear.split("-")[0];
  const year = monthYear.split("-")[1];
  return moment(+month + 1, "M").format("MMM") + " " + year;
};

const Transactions = () => {
  const { data: xp } = useGetWalletTransactionsQuery({
    entity: "xp",
  });
  const { data: coins } = useGetWalletTransactionsQuery({
    entity: "coins",
  });
  const [monthlyLedger, setMonthlyLedger] = useState<
    Record<string, WalletLedgers[]>
  >({});

  useEffect(() => {
    const newMonthlyLedger: Record<string, WalletLedgers[]> = {};

    // Combine both ledgers first
    const allTransactions = [
      ...(xp?.ledgerEntries?.map((entry: WalletLedgers) => ({
        ...entry,
        entity: "xp",
      })) || []),
      ...(coins?.ledgerEntries?.map((entry: WalletLedgers) => ({
        ...entry,
        entity: "coins",
      })) || []),
    ];

    // Sort all transactions by date in descending order
    allTransactions.sort(
      (a, b) => moment(b.created_at).valueOf() - moment(a.created_at).valueOf(),
    );

    // Group sorted transactions by month-year
    for (const transaction of allTransactions) {
      const month = moment(transaction.created_at).month().toString();
      const year = moment(transaction.created_at).year().toString();
      const monthYearKey = `${month}-${year}`;

      if (!newMonthlyLedger[monthYearKey]) {
        newMonthlyLedger[monthYearKey] = [transaction];
      } else {
        newMonthlyLedger[monthYearKey].push(transaction);
      }
    }

    setMonthlyLedger(newMonthlyLedger);
  }, [xp, coins]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <div className="flex flex-col w-full gap-6">
      <div className="flex  items-center text-primary-900 text-4xl font-bold leading-10 mb-2 hidden md:flex">
        <span>My Wallet</span>
        <div onClick={openModal} className="cursor-pointer ml-4 mt-1">
          <Info />
        </div>
      </div>
      {isModalOpen && <RewardsCriteria onClose={closeModal} />}
      {Object.keys(monthlyLedger)?.map((monthYear) => {
        if (monthlyLedger[monthYear]?.length > 0) {
          return (
            <div className="flex flex-col gap-4">
              <div className="text-[#808080] md:bg-transparent bg-[#EBEBEB] text-xs md:text-sm font-bold font-['SF Pro'] leading-4 tracking-[3px] uppercase">
                {formatMonthYear(monthYear)}
              </div>
              <div className="bg-white flex flex-col w-full md:rounded-lg px-4">
                {monthlyLedger[monthYear]?.map(
                  (row: WalletLedgers, index: number) => {
                    return (
                      <div
                        key={index}
                        className={`flex justify-between ${index !== monthlyLedger[monthYear].length - 1 ? "border-b-2" : ""} py-4`}
                      >
                        <div className="flex flex-col">
                          <p className="text-base font-semibold text-neutral-700 md:text-xl md:text-primary-900 capitalize">
                            {row.action.replace(/_/g, " ")}
                          </p>
                          <p className="text-xs text-[#999999] md:text-base md:text-neutral-700 font-normal">
                            {moment(row.created_at).format("DD/MM/YY h:mm A")}
                          </p>
                        </div>
                        <div className="flex items-center gap-x-1">
                          <span
                            className={`font-bold md:text-xl ${row.transaction_type === "credit" ? "text-[#34c759]" : "text-[#e74c3c]"}`}
                          >{`${row.transaction_type === "credit" ? "+" : "-"} ${row.amount}`}</span>
                          {row.entity === "coins" ? (
                            <img
                              className="w-4 h-4"
                              src="/assets/logo/OneGoldCoin.png"
                            ></img>
                          ) : (
                            <img
                              className="w-4 h-4"
                              src="/assets/icons/star-red.png"
                            ></img>
                          )}
                        </div>
                      </div>
                    );
                  },
                )}
              </div>
            </div>
          );
        } else return null;
      })}
    </div>
  );
};

export default Transactions;
